import { ActionFactory } from './../actions/ActionFactory.js';
import { Links, Type, DataTypes } from 'generated';
import { Converter } from './converter.js';
import { TaskManager } from './../screentask/TaskManager.js';
import { ServerAdapterFactory } from './ServerAdapterFactory.js'
import { Constants as C, methods as M } from "./methods.js";
import { ItemSubscription } from './ItemSubscription.js';

/**
 * @class ItemHistorySubscription
 * @classdesc Обработчик связей в проекте для playback
 */
export class ItemHistorySubscription {
    constructor(id, type) {

        this.options = {
            updatePeriod: 1000,
            interval: 1000,
            maxSize: 1000
        };
        this.SubPack = {
            "items": []
        };
        this.tryCount = 0;
        this.ItemsContainer = new Map();
        this.ServerAdapter = ServerAdapterFactory.GetAdapterInstance(id, type);
        this.ServerAdapter.reSubscribe = this.reSubscribe.bind(this);

    }

    async CreateDataSubscription() {
        const pack = {};
        let options = {
            method: M.CreatePlayerSubscription, //M.CreateDataHistorySubscription
            methodType: C.single, //?
            pack
        }
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => {
                this.ServerAdapter.subscriptionId = data.subscriptionId;
                resolve(data);
            });
        });
    }

    async CreateMonitoredDataItems(items, subId) {
        if (items.length > 0) {
            this.SubPack.items = items;
            this.SubPack.subscriptionId = subId || this.ServerAdapter.subscriptionId;
            let options = {
                pack: this.SubPack,
                method: M.AddSubscriptionItem,
                methodType: C.single,
            }
            items.forEach(item =>
                this.ItemsContainer.set(item.clientHandle, item)
            )
            return await new Promise(resolve => {

                this.ServerAdapter.sendRequest(options, data => resolve(data));
            });
        }
    }

    async GetArchiveItems(items, subId) {
        if (items.length > 0) {
            this.SubPack.items = items;
            this.SubPack.subscriptionId = subId || this.ServerAdapter.subscriptionId;
            let options = {
                pack: this.SubPack,
                method: M.GetArchiveItems,
                methodType: C.single,
            }
            items.forEach(item =>
                this.ItemsContainer.set(item.clientHandle, item)
            )
            return await new Promise(resolve => {

                this.ServerAdapter.sendRequest(options, data => resolve(data));
            });
        }
    }

    async AddSubscriptionItem(items, subId) {
        if (items.length > 0)
            this.SubPack.subscriptionId = subId || this.ServerAdapter.subscriptionId; {
            const options = {
                pack: {
                    items: items,
                    subscriptionId: this.SubPack.subscriptionId
                },
                method: M.AddSubscriptionItem,
                methodType: C.single,
            }
            return await new Promise(resolve => this.ServerAdapter.sendRequest(options, data => resolve(data)));
        }
    }


    async reSubscribe() {
        //const item = {
        //    type: 'error',
        //    time: new Date().toLocaleString(),
        //    title: 'Передан недействительный код подписки',
        //    text: '2150105088'
        //};
        //$ns.add(item);
        this.StopWatch();
        return await this.CreateDataSubscription()
            .then(response => this.CreateMonitoredDataItems([...this.ItemsContainer.values()], response.subscriptionId))
            .then(() => this.onRestore());
    }

    async DeleteDataSubscription() {
        const sessionId = $sw.sessionId;
        const subscriptionId = $sw.ItemSubscription.ServerAdapter.subscriptionId;

        console.log(sessionId, subscriptionId)

        const options = {
            pack: {
                sessionId: sessionId,
                subscriptionId: subscriptionId
            },
            method: M.DeleteDataSubscription,
            methodType: C.single
        }

        return await new Promise(resolve => this.ServerAdapter.sendRequest(options, data => resolve(data)));
    }

    async RunPlayerSubscription(startTime, endTime, speed, subscriptionId) {

        const options = {
            pack: {
                subscriptionId: subscriptionId,
                startTime: startTime,
                endTime: endTime,
                speed: speed
            },
            method: M.RunPlayerSubscription,
            methodType: C.single
        }
        console.log(options)
        return await new Promise(resolve => this.ServerAdapter.sendRequest(options, data => resolve(data)))
    }

    async PlayerPublishData(subscriptionId, sequenceNumber) {
        const pack = {};
        pack.subscriptionId = subscriptionId || this.ServerAdapter.subscriptionId;
        if (sequenceNumber) pack.sequenceNumber = sequenceNumber
        const options = {
            pack: pack,
            method: M.PlayerPublishData,
            methodType: C.single
        }
        console.log("OPTIONS", options)
        return await new Promise(resolve => this.ServerAdapter.sendRequest(options, data => resolve(data)))
    }

    LinkUp(data) {
        console.log($sw.ItemSubscription.LinkUp(data))
    }
}